import Vue from 'vue'

Vue.directive('click-outside', {
  bind: function (element, binding, vnode) {
    element.clickOutsideEvent = function (event) {
      if (!(element == event.target || element.contains(event.target))) {
        binding?.expression
          ? vnode.context[binding?.expression](event)
          : binding?.value.handler()
      }
    }

    document.body.addEventListener('click', element.clickOutsideEvent)
  },

  unbind: function (element) {
    document.body.removeEventListener('click', element.clickOutsideEvent)
  },
})
